/**
 * Deep freezes an object
 * @param obj: {object}
 * @return {object}
 */
export const deepFreeze = <T extends object>(obj: T): T => {
  Object
    .values(obj)
    .filter((prop) => typeof prop === 'object' && prop !== null)
    .forEach(deepFreeze);

  return Object.freeze(obj);
};

export const getCoverPhotoUrl = (coverPhotoUrls: string[]): string | undefined => coverPhotoUrls[0]?.replace('upload/', 'upload/fl_lossy,f_auto/');
